import { Component, Input, OnInit} from '@angular/core';
import {DocumentoPac} from 'src/app/model/DocumentoPac';

@Component({
  selector: 'app-informacoes-do-investimento',
  templateUrl: './informacoes-do-investimento.component.html',
  styleUrls: ['./informacoes-do-investimento.component.scss'],
  standalone: false
})
export class InformacoesDoInvestimentoComponent implements OnInit {

  @Input() documentoPac: DocumentoPac = new DocumentoPac();

  constructor() { }

  ngOnInit(): void {
  }
}
